import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { companyApi } from '../../services/api'

export default function Layout({ children }) {
    const { user, logout, isSysAdmin } = useAuth()
    const navigate = useNavigate()
    const [companyName, setCompanyName] = useState('Timesheets')

    useEffect(() => {
        loadCompanyName()
    }, [])

    async function loadCompanyName() {
        try {
            const data = await companyApi.getSettings()
            if (data.success && data.settings?.companyName) {
                const name = data.settings.companyName
                setCompanyName(name)
                document.title = `${name} Timesheets`
            }
        } catch (error) {
            // Keep default
        }
    }

    const handleLogout = async () => {
        await logout()
        navigate('/login')
    }

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Top Bar */}
            <header className="bg-rdi-blue text-white px-4 py-3 flex items-center justify-between shadow-md">
                <button
                    onClick={() => navigate('/')}
                    className="font-semibold text-lg hover:opacity-80 transition-opacity"
                >
                    {companyName} Timesheets
                </button>
                <div className="flex items-center gap-4">
                    <span className="text-sm opacity-90 hidden sm:inline">
                        {user?.fullName || user?.userName}
                        {isSysAdmin && <span className="ml-1 opacity-70">(Admin)</span>}
                    </span>
                    <button
                        onClick={handleLogout}
                        className="text-sm bg-white bg-opacity-20 hover:bg-opacity-30 px-3 py-1.5 rounded-lg transition-colors"
                    >
                        Log Out
                    </button>
                </div>
            </header>

            <main className="p-4 lg:p-6 max-w-7xl mx-auto">
                {children}
            </main>
        </div>
    )
}